import {Basic, Ventrata} from 'types'
import {getPricingByCurrency} from 'utils/getPricingByCurrency'

type UnitPricingMap = Record<string, number>

export const getProductPricingFromBooking = (
  product: Ventrata.Product,
  currency: Basic.Currency
): number | undefined => {
  let pricingFrom: number | undefined

  for (const option of product.options) {
    const optionPricingFrom = getPricingByCurrency(option.pricingFrom, currency)?.retail ?? 0

    if (pricingFrom === undefined || optionPricingFrom < pricingFrom) {
      pricingFrom = optionPricingFrom
    }
  }

  return pricingFrom
}

export const getProductPricingFromUnit = (product: Ventrata.Product, currency: Basic.Currency): UnitPricingMap => {
  const unitPricingMap: UnitPricingMap = {}

  for (const option of product.options) {
    for (const unit of option.units) {
      const savedUnitPricingFrom = unitPricingMap[unit.id]
      const unitPricingFrom = getPricingByCurrency(unit.pricingFrom, currency)?.retail || 0

      if (!savedUnitPricingFrom || unitPricingFrom < savedUnitPricingFrom) {
        unitPricingMap[unit.id] = unitPricingFrom
      }
    }
  }

  return unitPricingMap
}
